import { toast } from 'react-toastify'
import { getFusion } from '../apiHelper/fusionApi'
import { ENCOUNTER_TYPES } from '../views/pages/sharedConstants'

// gets global data practice encounter detail validations
export function getChartValidations() {
  let validations = JSON.parse(sessionStorage.getItem('directives/chart_validation'))
  if (validations) {
    return validations
  }

  return getFusion('v1/directives/chart_validation')
    .then((validationDirectives) => {
      if (validationDirectives?.status === 'failure') {
        throw validationDirectives
      }
      sessionStorage.setItem('directives/chart_validation', JSON.stringify(validationDirectives))
      return validationDirectives
    })
    .catch((e) => {
      console.error('DIRECTIVES_CHART_VALIDATION', e)
      return null
    })
}

// whether the codes chosen for a practice are allowed for 'Initial' types
export function initialCodesAllowed(validationDirectives) {
  let codesAllowed = null
  if (validationDirectives && validationDirectives.hasOwnProperty('initial_mips_required')) {
    const initialMipsRequired = validationDirectives['initial_mips_required']
    if (initialMipsRequired && initialMipsRequired.length > 0) {
      codesAllowed = initialMipsRequired
    }
  }
  if (codesAllowed === null) {
    console.error(`validation directive 'initial_mips_required' is not defined - returning []`)
    codesAllowed = []
  }
  return codesAllowed
}

// whether the codes chosen for a practice are allowed for 'Subsequent' types
export function subsequentCodesAllowed(validationDirectives) {
  let codesAllowed = null
  if (validationDirectives && validationDirectives.hasOwnProperty('subsequent_mips_required')) {
    const subsequentMipsRequired = validationDirectives['subsequent_mips_required']
    if (subsequentMipsRequired && subsequentMipsRequired.length > 0) {
      codesAllowed = subsequentMipsRequired
    }
  }
  if (codesAllowed === null) {
    console.error(`validation directive 'subsequent_mips_required' is not defined - returning []`)
    codesAllowed = []
  }
  return codesAllowed
}

// whether the codes chosen for a practice are allowed for a given encounterType
export function isProcedureValidWithEncounter(encounterType, procedureCodes, validationDirectives) {
  if (encounterType === ENCOUNTER_TYPES.INITIAL) {
    if (
      procedureCodes?.length > 0 &&
      !initialCodesAllowed(validationDirectives).includes(procedureCodes[0].code)
    ) {
      toast.error('1st procedure code selected is not valid for initial encounter')
      return false
    }
  } else if (encounterType === ENCOUNTER_TYPES.SUBSEQUENT) {
    if (
      procedureCodes?.length > 0 &&
      !subsequentCodesAllowed(validationDirectives).includes(procedureCodes[0].code)
    ) {
      toast.error('1st procedure code selected is not valid for subsequent encounter')
      return false
    }
  }
  return true
}
